// ============================================================================
// ENUM LOOKUP SERVICE
// Read-only lookup lists from common.tbl_enum_master. Single source of truth
// for dropdown option lists (COUNTRY, INDIAN_STATE, ID_TYPE, …) — replaces
// per-modal hardcoded arrays over time.
// ============================================================================

import { get } from '../client/axiosClient';
import { enumEndpoints } from '../endpoints/enum.endpoints';
import type { ApiResponse } from '../types';
import type { EnumItem } from '../types/enum.types';

class EnumService {
  async getByGroup(group: string): Promise<EnumItem[]> {
    const response = await get<ApiResponse<EnumItem[]>>(enumEndpoints.byGroup(group));
    return response.data?.data ?? [];
  }
}

export const enumService = new EnumService();
export default enumService;
